<template>
  <a-modal
    centered
    :visible="showModal"
    @cancel="handleCancel"
  >
    <template #title>
      <h3
        class="dedicated-request__title"
        v-html="modalTitle"
      ></h3>
    </template>

    <template #closeIcon>
      <svg-close></svg-close>
    </template>

    <dedicated-request
      :server="server"
      @submitForm="submitForm"
    ></dedicated-request>

    <template #footer>
      <button
        v-if="isSuccessfulRequest"
        class="btn btn--outline"
        @click="handleOk"
      >
        Понятно
      </button>
    </template>
  </a-modal>
</template>

<script>
  import SvgClose from '~/assets/icons/modal/close.svg'

  import DedicatedRequest from '~/components/forms/DedicatedRequest'

  export default {
    name: 'ServersAvailabilityModal',
    components: {
      SvgClose,
      DedicatedRequest
    },
    props: {
      isVisibleModal: {
        type: Boolean,
        required: true
      },
      server: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        isSuccessfulRequest: false
      }
    },
    computed: {
      showModal() {
        return this.isVisibleModal
      },
      modalTitle() {
        return this.isSuccessfulRequest
          ? 'Спасибо, мы получили вашу заявку!'
          : `Узнать о поступлении ${this.server.name}`
      }
    },
    methods: {
      setModalVisible(modalVisible) {
        this.$emit('setModalVisible', modalVisible)
      },
      submitForm(isSuccessfulRequest) {
        this.isSuccessfulRequest = isSuccessfulRequest
      },
      handleOk() {
        this.setModalVisible(false)
      },
      handleCancel() {
        this.setModalVisible(false)
      }
    }
  }
</script>

<style lang="scss">
.dedicated-request__title {
  color: $primary;
  margin-bottom: 0;
}
</style>